const isVisuelEffectSupported = () => {
  return (
    typeof MediaStreamTrackGenerator !== "undefined" &&
    typeof MediaStreamTrackProcessor !== "undefined"
  );
};
export default isVisuelEffectSupported;
